/**
 * Events selectors
 */
import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectEvent = (state: any) => state.events || initialState;

const makeSelectEventItem =
  createSelector(
    selectEvent,
    eventsState => eventsState.eventItem,
);

const makeSelectSimilarEvents =
  createSelector(
    selectEvent,
    eventsState => eventsState.similarEvents,
);

const makeSelectLoading =
  createSelector(
    selectEvent,
    eventsState => eventsState.loading.info,
);

const makeSelectExpiredEventsLoading =
  createSelector(
    selectEvent,
    eventsState => eventsState.loadingExpiredEvents,
);

const makeSelectLoadingButton =
  createSelector(
    selectEvent,
    eventsState => eventsState.loadingButton,
);

const makeSelectLoadingSimilar =
  createSelector(
    selectEvent,
    eventsState => eventsState.loadingSimilar,
);

const makeSelectEventsPage = 
  createSelector(
    selectEvent,
    eventsState => eventsState.page,
);

const makeSelectEvents = 
  createSelector(
    selectEvent,
    eventsState => eventsState.events,
);

const makeSelectExpiredEvents = 
  createSelector(
    selectEvent,
    eventsState => eventsState.expiredEvents,
);

const makeSelectCompanies = 
  createSelector(
    selectEvent,
    eventsState => eventsState.companies,
);

const makeSelectPageCount = createSelector(
  selectEvent,
  eventsState => eventsState.pageCount,
)

const makeSelectCurrentPage = createSelector(
  selectEvent,
  eventsState => eventsState.currentPage,
);

const optionsCitiesSelector = createSelector(
  selectEvent,
  eventsState => eventsState.optionsCities,
);

const cityLoadingSelector = createSelector(
  selectEvent,
  eventsState => eventsState.loading.cities,
);

const companyLoadingSelector = createSelector(
  selectEvent,
  eventsState => eventsState.loading.companies,
);

const makeSelectExpiredPageCount = createSelector(
  selectEvent,
  eventsState => eventsState.expiredPageCount,
)

const makeSelectExpiredCurrentPage = createSelector(
  selectEvent,
  eventsState => eventsState.expiredCurrentPage,
);

const makeSelectSimilarPageCount = createSelector(
  selectEvent,
  eventsState => eventsState.similarPageCount,
)

const makeSelectSimilarCurrentPage = createSelector(
  selectEvent,
  eventsState => eventsState.similarCurrentPage,
);

const makeSelectPackages = createSelector(
  selectEvent,
  eventsState => eventsState.packages,
);

const makeSelectEventItemError =
  createSelector(
    selectEvent,
    eventsState => eventsState.error,
);

export { 
    makeSelectEventItem,
    makeSelectLoading,
    makeSelectLoadingSimilar,
    makeSelectEventsPage,
    makeSelectEvents,
    makeSelectExpiredEvents,
    makeSelectExpiredEventsLoading,
    makeSelectCompanies,
    makeSelectCurrentPage,
    makeSelectPageCount,
    optionsCitiesSelector,
    cityLoadingSelector,
    makeSelectLoadingButton,
    makeSelectSimilarCurrentPage,
    makeSelectSimilarPageCount,
    makeSelectSimilarEvents,
    makeSelectPackages,
    companyLoadingSelector,
    makeSelectExpiredPageCount,
    makeSelectExpiredCurrentPage,
    makeSelectEventItemError
 };
